//QA
export const basePath = process.env.REACT_APP_API_URL || '';
